import { MissingReference } from "./MissingReference";
import { MapUtils } from "../../../../core/MapUtils";
import { CoreWalker } from "../../../../core/Walker";
import { SetUtils } from "../../../../core/SetUtils";
export class MissingReferencesController {
  constructor(scene) {
    this.scene = scene;
    this.references = /* @__PURE__ */ new Map();
  }
  register(param, path) {
    const missingReference = new MissingReference(param, path);
    MapUtils.addToSetAtEntry(this.references, param.graphNodeId(), missingReference);
    return missingReference;
  }
  deregisterParam(param) {
    this.references.delete(param.graphNodeId());
  }
  resolveMissingReferences() {
    const resolvedReferences = [];
    this.references.forEach((references) => {
      for (let reference of references) {
        if (this._isReferenceResolvable(reference)) {
          resolvedReferences.push(reference);
        }
      }
    });
    for (let reference of resolvedReferences) {
      reference.resolveMissingDependencies();
    }
  }
  _isReferenceResolvable(reference) {
    const absolutePath = reference.absolutePath();
    if (absolutePath) {
      const node = this.scene.node(absolutePath);
      if (node) {
        return true;
      } else {
        const paths = CoreWalker.splitParentChild(absolutePath);
        if (paths.child) {
          const parentNode = this.scene.node(paths.parent);
          if (parentNode) {
            const param = parentNode.params.get(paths.child);
            if (param) {
              return true;
            }
          }
        }
      }
    }
  }
  checkForMissingNodeReferences(node) {
    if (!node.scene().loadingController.loaded()) {
      return;
    }
    this._checkForMissingReferencesForNode(node);
    for (let param of node.params.all) {
      this._checkForMissingReferencesForParam(param);
    }
  }
  checkForMissingParamReferences(param) {
    if (!param.scene().loadingController.loaded()) {
      return;
    }
    this._checkForMissingReferencesForParam(param);
  }
  _checkForMissingReferencesForNode(node) {
    const id = node.graphNodeId();
    const missingReferences = MapUtils.arrayFromValues(this.references);
    for (let missingReference of missingReferences) {
      let matchFound = false;
      const list = SetUtils.toArray(missingReference);
      for (let ref of list) {
        if (ref.matchesPath(node.path())) {
          matchFound = true;
          ref.resolveMissingDependencies();
        }
      }
      if (matchFound) {
        this.references.delete(id);
      }
    }
  }
  _checkForMissingReferencesForParam(param) {
    const id = param.graphNodeId();
    const missingReferences = MapUtils.arrayFromValues(this.references);
    for (let missingReference of missingReferences) {
      let matchFound = false;
      const list = SetUtils.toArray(missingReference);
      for (let ref of list) {
        if (ref.matchesPath(param.path())) {
          matchFound = true;
          ref.resolveMissingDependencies();
        }
      }
      if (matchFound) {
        this.references.delete(id);
      }
    }
  }
}
